import React, { useContext, useState, useEffect } from 'react';
import { ReactComponent as Icon } from '../../assets/login.svg';
import Navbar from '../../components/navbar';
import PersonOutlineIcon from '@material-ui/icons/PersonOutline';
import LockIcon from '@material-ui/icons/Lock';
import { useForm } from 'react-hook-form';
import './style.scss';
import { Context } from '../../store';
import axios from 'axios';
import CustomSnackbar from '../../components/snack';
import CustomLoader from '../../components/loader/customLoader';
import { BACKURL } from '../../components/network';

const Login = (props) => {
  const { register, handleSubmit } = useForm();
  const { dispatch } = useContext(Context);
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState('');
  const [loading, setLoading] = useState(false);
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };
  useEffect(() => {
    if (localStorage.getItem('copy-user')) {
      props.history.push('/main');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const sendData = async (details) => {
    // console.log(details);
    setLoading(true);
    const data = await axios.post(`${BACKURL}/login`, details);
    // const data = await axios.post('http://192.168.0.104:5050/login', details);

    setLoading(false);
    // return data
    if (data.data.done) {
      const userData = {
        username: data.data.data.username,
        userImg: data.data.data.userImg,
        token: data.data.token,
        email: data.data.data.email,
        globalColor: data.data.data.globalColor,
      };
      dispatch({
        type: 'USER_LOGIN',
        payload: userData,
      });
      // dispatch({ type: 'USER_LOGIN', payload: data.data.data });
      props.history.push('/main');
    } else {
      setMsg(data.data.msg);
      setOpen(true);
    }
    // return data.data
  };

  const Submit = async (data) => {
    // console.log(data);
    await sendData(data);
    // dispatch({ type: 'USER_LOGIN', payload: data.username || 'bdbose' });
    // props.history.push('/main');
  };
  return (
    <>
      {loading ? <CustomLoader /> : null}
      <div className='login-wrapper'>
        <Navbar props={props} />
        <div className='login-icon'>
          <Icon />
        </div>
        <form className='login-btn' onSubmit={handleSubmit(Submit)}>
          <div className='input-btn'>
            <PersonOutlineIcon />
            <input
              name='email'
              ref={register}
              type='email'
              placeholder='Email'
              required
            />
          </div>
          <div className='input-btn'>
            <LockIcon />
            <input
              name='password'
              ref={register}
              type='password'
              placeholder='Password'
              required
            />
          </div>
          <button>Login</button>
        </form>
        <div className='redirect-btn'>
          New User? <a href='/register'>&nbsp;Register</a>
        </div>
        <CustomSnackbar open={open} handleClose={handleClose} msg={msg} />
      </div>
    </>
  );
};

export default Login;
